<template>
  <div class="pp-apartment-buildings-component pp-type-component">
    <div class="section-loading-screen" v-if="showLoading">
      <div class="section-loading-bubbles">
        <span class="d1"></span>
        <span class="d2"></span>
        <span class="d3"></span>
        <span class="d4"></span>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mb-4">
        <a
          href="javascript:history.back()"
          class="pp-buildings-page-link"
          v-if="backButtonInDomain"
        >
          <i class="fad fa-long-arrow-left"></i> Inapoi
        </a>
        <a
          :href="`${project.url}`"
          class="pp-buildings-page-link"
          v-else
        >
          <i class="fad fa-long-arrow-left"></i> Pagina de proiect
        </a>
        <a
          href="javascript:history.back()"
          class="pp-buildings-page-link pp-buildings-page-link--mobile ml-0"
          v-if="backButtonInDomain"
        >
          <i class="fad fa-long-arrow-left"></i> Inapoi
        </a>
        <a
          :href="`${project.url}`"
          class="pp-buildings-page-link pp-buildings-page-link--mobile ml-0"
          v-else
        >
          <i class="fad fa-long-arrow-left"></i> Pagina de proiect
        </a>
      </div>
      <div class="col-3 d-none d-lg-block">
        <div class="p-buildings-list">
          <div class="p-buildings-list__title">Alege un bloc:</div>
          <ul class="nav nav-tabs model-detail-tablist">
            <li
              class="nav-item"
              v-for="(building, index) in buildings"
              :key="index"
              @click="selectBuilding(index)"
            >
              <a
                :class="[
                  'nav-link model-modal-active-tab',
                  { active: index == selectedBuilding },
                ]"
              >
                <i class="fad fa-city"></i>
                <span> Bloc {{ building.name }} </span>
                <span class="date"> {{ building.finalized_date }} </span>
                <p class="general-counter">{{ building.items_count }}</p>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-12 col-lg-9">
        <div class="p-building-content">
          <div class="p-building-content__title">
            <strong>Lista de preturi si disponibilitati</strong> -
            {{ project.name }}
            <span v-if="project.zone && project.zone.name"
              >- {{ project.zone.name }}</span
            ><span v-if="project.city && project.city.name">
              - {{ project.city.name }}</span
            >
          </div>
          <div
            class="p-building-content__title p-building-content__title--mobile"
          >
            {{ project.name }}
            <span v-if="project.zone && project.zone.name"
              >- {{ project.zone.name }}</span
            ><span v-if="project.city && project.city.name">
              - {{ project.city.name }}</span
            >
            <br />
            <strong>Lista de preturi si disponibilitati</strong>
            <small>Alege un bloc: </small>
          </div>
          <div class="p-buildings-mobile d-block d-lg-none">
            <div
              :class="[
                'p-buildings-mobile__header',
                {
                  'p-buildings-mobile__header--shadow':
                    mobileBuildingsHeaderShadow,
                },
              ]"
              @click="showMobileBuildingsList = !showMobileBuildingsList"
            >
              <div
                v-for="(building, i) in buildings"
                :key="'building-selector-header' + i"
                :class="[
                  'p-buildings-mobile__building',
                  { 'd-none': i !== selectedBuilding },
                ]"
              >
                <div class="p-building__name">
                  Bloc {{ building.name }}
                  <span
                    class="p-building__date p-building__date--mobile"
                    v-if="building.finalized_date"
                  >
                    - {{ building.finalized_date }}
                  </span>
                </div>
              </div>
              <i
                class="fas fa-chevron-down"
                v-if="!showMobileBuildingsList"
              ></i>
              <i class="fas fa-chevron-up" v-else></i>
            </div>
            <div
              class="p-buildings-mobile__list-mask d-block d-lg-none"
              v-if="showMobileBuildingsList"
              @click="showMobileBuildingsList = false"
            ></div>
            <div
              class="p-buildings-mobile__list d-block d-lg-none"
              v-if="showMobileBuildingsList"
            >
              <div
                v-for="(building, i) in buildings"
                :key="'building-selector-item' + i"
                :class="[
                  'p-buildings-mobile__building',
                  {
                    'p-buildings-mobile__building--active':
                      i == selectedBuilding,
                  },
                ]"
                @click="selectBuilding(i)"
              >
                <div class="p-building__name">
                  Bloc {{ building.name }}
                  <span
                    class="p-building__date p-building__date--mobile"
                    v-if="building.finalized_date"
                  >
                    - {{ building.finalized_date }}
                  </span>
                </div>
                <div class="p-building__offers">
                  ({{ building.items_count }} oferte disponibile)
                </div>
              </div>
            </div>
          </div>
          <div
            v-for="(building, i) in buildings"
            :key="'building' + i"
            :class="['p-building', { 'd-none': i !== selectedBuilding }]"
            :id="`building-${building.id}`"
          >
            <div class="p-building__header d-none d-lg-flex">
              <div class="p-building__name">
                Bloc {{ building.name }}
                <span class="p-building__date" v-if="building.finalized_date">
                  Termen de finalizare: {{ building.finalized_date }}
                </span>
                <span
                  class="p-building__date p-building__date--mobile"
                  v-if="building.finalized_date"
                >
                  - {{ building.finalized_date }}
                </span>
              </div>
              <div
                class="p-building__toggle-offers"
                @click="toggleUnavailableOffers(building.id)"
              >
                Vezi doar ofertele disponibile ({{ building.items_count }})
              </div>
            </div>
            <div class="p-building__levels">
              <div
                class="
                  p-building__toggle-offers p-building__toggle-offers--mobile
                "
                @click="toggleUnavailableOffers(building.id)"
              >
                Vezi doar ofertele disponibile ({{ building.items_count }})
              </div>
              <div
                class="p-building__level"
                v-for="(level, j) in building.levels"
                :key="'level' + j"
                v-show="level.items.length > 0"
              >
                <div
                  class="p-building__level-header"
                  role="button"
                  data-toggle="collapse"
                  :data-target="`#building-level-b${building.id}-l${level.id}`"
                  aria-expanded="true"
                  :aria-controls="`#building-level-b${building.id}-l${level.id}`"
                >
                  <div class="p-building__level-toggle">
                    <i class="fas fa-chevron-down"></i>
                    <i class="fas fa-chevron-up"></i>
                  </div>
                  <div class="p-building__level-name">
                    {{ level.name }}
                  </div>
                  <div class="p-building__level-sold-out">
                    <span v-if="level.items.length == level.soldOffers">
                      (toate ofertele sunt vandute pe acest etaj)
                    </span>
                  </div>
                  <span class="p-building__level-tag"> Suprafata </span>
                  <span class="p-building__level-tag"> Pret </span>
                  <span class="p-building__level-tag"> Pret cu credit </span>
                  <span class="p-building__level-tag"> Status </span>
                  <div class="p-building__level-header-spacer"></div>
                </div>
                <div
                  class="p-building__level-list collapse show"
                  :id="`building-level-b${building.id}-l${level.id}`"
                >
                  <div
                    v-for="(item, k) in level.items"
                    :key="'item' + k"
                    class="p-building__level-item"
                    :class="
                      item.status !== 'available'
                          ? 'p-building__level-item--unavailable'
                          : 'p-building__level-item--available'
                    "
                  >
                    <div class="p-building__level-item-content">
                      <div class="p-building__level-item-number">
                        <span v-if="item.model.type == 'commercial'">
                          Sp.
                          <br />
                          <span v-if="item.apartment_number">
                            {{ item.apartment_number }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span v-else>
                          Ap.
                          <br />
                          <span v-if="item.apartment_number">
                            {{ item.apartment_number }}
                          </span>
                          <span v-else> - </span>
                        </span>
                      </div>
                      <a
                        href="javascript:void(0)"
                        class="p-building__level-item-name"
                        @click="
                          openModelDetailModal(
                            project.id,
                            item.model.id,
                            'commercial'
                          )
                        "
                        v-if="item.model.type == 'commercial'"
                      >
                        Spatiu comercial tip {{ item.model.model_type }}
                      </a>
                      <a
                        href="javascript:void(0)"
                        class="p-building__level-item-name"
                        @click="
                          openModelDetailModal(
                            project.id,
                            item.model.id,
                            'apartments'
                          )
                        "
                        v-else
                      >
                        {{
                          item.model.rooms_count
                            ? item.model.rooms_count.name
                            : ""
                        }}
                        <span v-if="item.model.model_type"
                          >, tip {{ item.model.model_type }}</span
                        >
                      </a>
                      <div class="p-building__level-item-surface">
                        <div>
                          {{ item.useful_surface }} m<sup>2</sup>
                          <span>(totala)</span>
                        </div>
                        <div v-if="item.terrace_surface">
                          {{ item.terrace_surface }} m<sup>2</sup> (balcon)
                        </div>
                      </div>
                      <div
                        class="p-building__level-item-price"
                        v-if="item.status == 'available'"
                      >
                        <div>
                          {{ formatPrice(item.price) }}
                        </div>
                        <div>
                          {{ item.price_with_vat ? "TVA inclus" : "+TVA" }}
                        </div>
                      </div>
                      <div class="p-building__level-item-price" v-else>
                        <div>-</div>
                      </div>
                      <div
                        class="
                          p-building__level-item-price
                          p-building__level-item-price--credit
                        "
                        v-if="item.credit_price && item.status == 'available'"
                      >
                        <div>
                          {{ formatPrice(item.credit_price) }}
                        </div>
                        <div>
                          {{
                            item.credit_price_with_vat ? "TVA inclus" : "+TVA"
                          }}
                        </div>
                      </div>
                      <div
                        class="
                          p-building__level-item-price
                          p-building__level-item-price--credit
                        "
                        v-else
                      >
                        <div>-</div>
                      </div>
                      <div class="p-building__level-item-status">
                        {{
                          item.status === "available" ? "Disponibil" : "Vandut"
                        }}
                      </div>
                      <a
                        href="javascript:void(0)"
                        class="p-building__level-item-link"
                        @click="
                          openModelDetailModal(
                            project.id,
                            item.model.id,
                            'apartments'
                          )
                        "
                      >
                        Vezi detalii
                      </a>
                    </div>
                    <div
                      class="
                        p-building__level-item-content
                        p-building__level-item-content--mobile
                      "
                    >
                      <div class="p-building__level-item-tags">
                        <span
                          >Ap.
                          <span v-if="item.apartment_number">{{
                            item.apartment_number
                          }}</span
                          ><span v-else> - </span></span
                        >
                        <span>Suprafata</span>
                        <span>Pret</span>
                        <span
                          v-if="item.credit_price && item.status == 'available'"
                          class="p-building__level-item-value"
                          >Pret cu credit</span
                        >
                        <span>Status</span>
                      </div>
                      <div class="p-building__level-item-values">
                        <a
                          href="javascript:void(0)"
                          class="
                            p-building__level-item-value
                            p-building__level-item-value--name
                          "
                          @click="
                            openModelDetailModal(
                              project.id,
                              item.model.id,
                              'apartments'
                            )
                          "
                        >
                          {{
                            item.model.rooms_count
                              ? item.model.rooms_count.name
                              : ""
                          }}, {{ item.model.model_type }}
                        </a>
                        <div
                          class="
                            p-building__level-item-value
                            p-building__level-item-value--surface
                          "
                        >
                          <span
                            >{{ item.useful_surface }} m<sup>2</sup>
                            <small>(totala)</small></span
                          >
                          <span v-if="item.terrace_surface"
                            >{{ item.terrace_surface }} m<sup>2</sup>
                            <small>(balcon)</small></span
                          >
                        </div>
                        <div
                          class="p-building__level-item-value"
                          v-if="item.status == 'available'"
                        >
                          {{ formatPrice(item.price) }}
                          <small>{{
                            item.price_with_vat ? "TVA inclus" : "+TVA"
                          }}</small>
                        </div>
                        <div class="p-building__level-item-value" v-else>-</div>
                        <div
                          v-if="item.credit_price && item.status == 'available'"
                          class="p-building__level-item-value"
                        >
                          {{ formatPrice(item.credit_price) }}
                          <small>{{
                            item.model.credit_price_with_vat
                              ? "TVA inclus"
                              : "+TVA"
                          }}</small>
                        </div>
                        <div class="p-building__level-item-value">
                          <span>
                            {{
                              item.status === "available"
                                ? "Disponibil"
                                : "Vandut"
                            }}
                          </span>
                          <a
                            href="javascript:void(0)"
                            class="p-building__level-item-link"
                            @click="
                              openModelDetailModal(
                                project.id,
                                item.model.id,
                                'apartments'
                              )
                            "
                          >
                            Vezi detalii
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="p-building__level-sold d-none"
                    v-if="level.soldOffers > 0"
                    @click="showLevelSoldOffers(building.id, level.id)"
                  >
                    + {{ level.soldOffers }} oferte vandute
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-building-footer__list d-block d-lg-none">
            <div>
              <strong class="p-building-footer__block-list"
                >Lista de blocuri din acest proiect.</strong
              >
              <br />
              <span class="p-building-footer__block-list"
                >Alege un bloc si vezi ofertele disponibile.</span
              >
            </div>
            <br />
            <div
              v-for="(building, i) in buildings"
              :key="'building-mobile' + i"
              :class="[
                'p-building-footer__building',
                {
                  'p-building-footer__building--active': i == selectedBuilding,
                },
              ]"
              @click="selectBuilding(i)"
            >
              <div class="p-building-footer__building-name">
                Bloc {{ building.name }}
                <span
                  class="p-building__date p-building__date--mobile"
                  v-if="building.finalized_date"
                >
                  - {{ building.finalized_date }}
                </span>
              </div>
              <div class="p-building-footer__building-offers">
                ({{ building.items_count }} oferte disponibile)
              </div>
            </div>
          </div>

          <div class="social-icon-desktop">
            <div>
              <strong class="p-building-footer__block-list"
                >Esti interesat de proiectul {{ project.name }}?</strong
              >
            </div>
            <div>
              <span class="p-building-footer__block-list"
                >Contacteaza dezvoltatorul si programeaza o vizionare.</span
              >
            </div>
            <br />
            <div
              class="
                p-building-footer_block-list
                p-building-footer_block-list--social-icon
              "
            >
              <div
                class="model-modal-details__button"
                @click="openPublicContactModalProject(project, model)"
              >
                <i class="fas fa-phone"></i>
                Contact
              </div>
              <div
                v-if="isFavorite"
                class="model-modal-details__button"
                @click="deleteFavoriteProject(project.id)"
              >
                <i class="fas fa-heart u-color-danger"></i> Salvat la favorite
              </div>
              <div
                v-else
                class="model-modal-details__button"
                @click="saveFavoriteProject(project)"
              >
                <i class="fas fa-heart"></i> Salvează la favorite
              </div>
              <div
                class="model-modal-details__button"
                @click="shareDropdown = !shareDropdown"
              >
                <i class="fas fa-share-square"></i>
                Distribuie lista
              </div>
              <div class="element-dropdown element-dropdown-project">
                <ul
                  class="actions-dropdown actions_dropdown_active"
                  v-if="shareDropdown"
                  ref="dropdown"
                >
                  <li>
                    <i class="fad fa-copy"></i>
                    <a
                      href="javascript:void(0)"
                      class="general-link"
                      @click="copyLinkList(project)"
                      >Copy link
                    </a>
                  </li>
                  <li>
                    <i class="fab fa-whatsapp"></i>
                    <a
                      :href="`https://api.whatsapp.com/send?text=${project.absoluteBuildingsUrl}`"
                      class="general-link"
                      target="_blank"
                      >Share Whatsapp</a
                    >
                  </li>
                  <li>
                    <i class="fab fa-facebook-square"></i>
                    <a
                      :href="`https://www.facebook.com/sharer/sharer.php?u=${project.absoluteBuildingsUrl}`"
                      class="general-link"
                      target="_blank"
                      >Share Facebook</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <br />

          <div class="model-modal-details__footerFixed">
            <div
              class="model-modal-details__button"
              @click="openPublicContactModalProject(project, model)"
            >
              <i class="fas fa-phone"></i>
              Contact
            </div>
            <div
              v-if="isFavorite"
              class="
                model-modal-details__button model-modal-details__button--fav
              "
            >
            
              <i
                class="fas fa-heart u-color-danger"
                @click="deleteFavoriteProject(project.id)"
              ></i>
              Sterge
            </div>
            <div
              v-else
              class="
                model-modal-details__button model-modal-details__button--fav
              "
            >
              <i
                class="fas fa-heart"
                @click="openAddFavoriteProjectModal(project.id)"
              ></i>
              Salveaza
            </div>
            <div
              class="model-modal-details__button"
              @click="shareDropdown = !shareDropdown"
            >
              <i class="fas fa-share-square"></i>
              Distribuie lista
            </div>
            <div class="element-dropdown element-dropdown-project">
              <ul
                class="actions-dropdown actions_dropdown_active"
                v-if="shareDropdown"
                ref="dropdown"
              >
                <li>
                  <i class="fad fa-copy"></i>
                  <a
                    href="javascript:void(0)"
                    class="general-link"
                    @click="copyLinkList(project)"
                    >Copy link
                  </a>
                </li>
                <li>
                  <i class="fab fa-whatsapp"></i>
                  <a
                    :href="`https://api.whatsapp.com/send?text=${project.absoluteBuildingsUrl}`"
                    class="general-link"
                    target="_blank"
                    >Share Whatsapp</a
                  >
                </li>
                <li>
                  <i class="fab fa-facebook-square"></i>
                  <a
                    :href="`https://www.facebook.com/sharer/sharer.php?u=${project.absoluteBuildingsUrl}`"
                    class="general-link"
                    target="_blank"
                    >Share Facebook</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PublicProjectBuildings",
  props: ["project", "userId"],
  data() {
    return {
      showLoading: true,
      levels: [],
      roomsCountFilter: [],
      selectedBuilding: 0,
      buildings: [],
      buildingSlug: null,
      showMobileBuildingsList: false,
      backButtonInDomain: false,
      mobileBuildingsHeaderShadow: false,
      shareDropdown: false,
      isFavorite: false,
      deletedFavorite: false,
      deleteFavorite: false,
      favorites: [],
    };
  },
  async mounted() {
    this.showLoading = true;
    await this.getBuildingsData();
    this.favorites = window.getLocalFavorites();

    // console.log(this.project);
    this.setBackButton();
    window.addEventListener("scroll", this.toggleMobileBuildingsHeaderShadow);
    this.checkFavoriteProject(this.project.id);
   

  },
  beforeDestroy() {
    window.removeEventListener(
      "scroll",
      this.toggleMobileBuildingsHeaderShadow
    );
  },
  computed: {
    isAgent() {
      return this.userId == this.project.user.id;
    },
  },
  watch: {
    showMobileBuildingsList(newValue) {
      if (newValue && window.innerWidth <= 991)
        document.body.classList.add("modal-open");
      else document.body.classList.remove("modal-open");
    },
  },
  methods: {
    checkFavoriteProject(projectId) {
      if (this.favorites && this.favorites.length > 0) {
        let exists = this.favorites.filter(
          (favorite) =>
            favorite.favoritable_type == "App\\Project" &&
            favorite.favoritable_id === projectId
        );
        this.isFavorite = exists.length > 0;
      } else {
        this.isFavorite = false;
        
      }
    },
    deleteFavoriteProject(id) {
      let vm = this;
      this.isFavorite = false;
      if (vm.favProjects) {
        // logged in
        window.axios
          .delete(`/ajax/favorites/${id}/project`)
          .then(function () {
            vm.favorites.forEach(function (fav, key) {
              if (
                fav.favoritable_type === "App\\Project" &&
                fav.favoritable_id === id
              ) {
                vm.favorites.splice(key, 1);
                vm.deletedFavorite = true;
                vm.$eventBus.$emit("DELETED_FAVORITES_MODAL", {
                  favId: id,
                });
              }
            });
            window.Swal.fire({
              position: "top-end",
              icon: "success",
              html: "Modelul a fost sters din lista de favorite.",
              showConfirmButton: false,
              timer: 1500,
            });
          })
          .catch(function (err) {
            window.showError(err);
          });
      } else {
        vm.favorites = vm.favorites.filter(
          (fav) =>
            !(
              fav.favoritable_type === "App\\Project" &&
              fav.favoritable_id === id
            )
        );
        window.saveLocalFavorites(vm.favorites);

        window.Swal.fire({
          position: "top-end",
          icon: "success",
          html: "Modelul a fost sters din lista de favorite.",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
    saveFavoriteProject(project) {
      this.openAddFavoriteProjectModal(project.id);
       this.isFavorite = true;
    },

    getBuildingsData() {
      let vm = this;
      this.showLoading = true;
      window.axios
        .get(
          `/ajax/get-buildings-by-model-types-with-items/${this.project.id}/apartment-commercial`
        )
        .then(function (resp) {
          vm.buildings = resp.data.data;
          // console.log(resp);
          vm.groupLevelItems();
          vm.setInitialBuilding();
          vm.showLoading = false;
        })
        .catch(function () {
          vm.showLoading = false;
        });
    },
    groupLevelItems() {
      this.buildings.forEach((building) => {
        building.showUnavailableOffers = true;
        building.levels.forEach((level) => {
          level.items = [];
          level.soldOffers = 0;
          building.items.forEach((item) => {
            if (item.level_id == level.id) {
              level.items.push(item);
              if (item.status == "sold") level.soldOffers++;
            }
          });
        });
      });
    },
    toggleUnavailableOffers(buildingId) {
      const unavailableItems = document.querySelectorAll(
        `#building-${buildingId} .p-building__level-item--unavailable`
      );
      const unavailableText = document.querySelectorAll(
        `#building-${buildingId} .p-building__level-sold`
      );
      const toggle = document.querySelector(
        `#building-${buildingId} .p-building__toggle-offers`
      );
      const toggleMobile = document.querySelector(
        `#building-${buildingId} .p-building__toggle-offers--mobile`
      );
      this.buildings.forEach((building) => {
        if (building.id == buildingId) {
          if (building.showUnavailableOffers) {
            unavailableItems.forEach((item) => {
              item.classList.add("d-none");
            });
            unavailableText.forEach((item) => {
              item.classList.remove("d-none");
            });
            toggle.innerHTML = "Arata toate ofertele";
            toggleMobile.innerHTML = "Arata toate ofertele";
          } else {
            unavailableItems.forEach((item) => {
              item.classList.remove("d-none");
            });
            unavailableText.forEach((item) => {
              item.classList.add("d-none");
            });
            toggle.innerHTML = `Arata doar ofertele disponibile (${building.items_count})`;
            toggleMobile.innerHTML = `Arata doar ofertele disponibile (${building.items_count})`;
          }
          building.showUnavailableOffers = !building.showUnavailableOffers;
        }
      });
    },
    showLevelSoldOffers(buildingId, levelId) {
      const levelSoldOffers = document.querySelectorAll(
        `#building-level-b${buildingId}-l${levelId} .p-building__level-item--unavailable`
      );
      const levelSoldOffersToggle = document.querySelector(
        `#building-level-b${buildingId}-l${levelId} .p-building__level-sold`
      );
      levelSoldOffers.forEach((offer) => {
        offer.classList.remove("d-none");
      });
      levelSoldOffersToggle.classList.add("d-none");
    },
    selectBuilding(index) {
      this.selectedBuilding = index;
      this.showMobileBuildingsList = false;
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    setInitialBuilding() {
      let buildingSlugIndex = window.location.href.indexOf("#b-");
      if (buildingSlugIndex !== -1) {
        let buildingId = window.location.href.substring(buildingSlugIndex + 3);
        for (let i = 0; i < this.buildings.length; i++) {
          if (this.buildings[i].id == buildingId) {
            this.selectedBuilding = i;
            return;
          }
        }
      } else {
        this.showMobileBuildingsList = true;
      }
    },
    setBackButton() {
      if (document.referrer.split("/")[2] != location.hostname) {
        this.backButtonInDomain = false;
      } else {
        this.backButtonInDomain = true;
      }
    },
    toggleMobileBuildingsHeaderShadow() {
      this.mobileBuildingsHeaderShadow =
        window.top.scrollY >= 160 ? true : false;
    },
  },
};
</script>